import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { TableComponent, TH, THeadTR } from "../../../../components/Table v2";
import { IconPencilRevert, IconTrash } from "../../../../icons";
import { deleteProfile, getProfiles } from "../../service";
import { ModalMessage } from "../../../../components/ModalMessage";
import IconButton from "../../../../components/IconButton";
import Title from "../../../../components/Title";
import useAuthData from "../../../../hook/useAppData";
import Spinner from "../../../../components/Spinner";
import ButtonNavigator from "../../../../components/ButtonNavigator";
import { toastError, toastSuccess } from "../../../../components/Toast";
import { Toaster } from "react-hot-toast";
import { orderByName } from "../../../../libs/orderList";

type Profile = {
  id: number;
  name: string;
};

export function ListProfiles() {
  const { token } = useAuthData();
  const [profiles, setProfiles] = useState<Profile[]>();
  const [needSpinner, setNeedSpinner] = useState(true);
  const [modalDelete, setModalDelete] = useState<Profile>();
  const [page, setPage] = useState<number>(1);
  const [selectSize, setSelectSize] = useState<number>(10);

  const history = useHistory();

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 1000);
  }, [profiles]);

  async function getProfile() {
    const profiles: Profile[] = await getProfiles(token);
    const profilesOrderByName = orderByName(profiles, "name");
    setProfiles(profilesOrderByName);
  }

  async function handleDeleteConfirm(id: number) {
    const res = await deleteProfile({ token, id });
    if (!res?.ok) return toastError("Não foi possivel deletar o Perfil");
    getProfile();
    return toastSuccess("Perfil deletado com sucesso!");
  }

  function renderList(index: number) {
    const finalRender = (page + 1) * selectSize;
    const startRender = page * selectSize;
    return index >= startRender && index < finalRender;
  }

  return (
    <>
      <Toaster />
      <ModalMessage
        status={!!modalDelete?.id}
        text={`Deletar o Perfil '${modalDelete?.name}'`}
        onClickCancel={() => setModalDelete(undefined)}
        onClickConfirm={() => handleDeleteConfirm(modalDelete?.id)}
      />
      <Spinner status={needSpinner}>
        <div className="container ">
          <Title title="Perfis">
            <Link className="bg-primary border-none rounded-lg px-4 py-2 text-center text-1.6rem" to="profile/form">
              Novo Perfil
            </Link>
          </Title>
          <TableComponent className="rounded-lg mt-8">
            <THeadTR>
              <TH className="text-left">Perfil</TH>
              <TH className="w-1/5 ">Editar</TH>
              <TH className="w-1/5">Deletar</TH>
            </THeadTR>
            <tbody>
              {profiles?.length ? (
                profiles?.map((profile, index) => {
                  return (
                    renderList(index) && (
                      <tr className="border-b-2 border-background">
                        <td className="pl-4">{profile?.name}</td>
                        <td>
                          <IconButton
                            onClick={() => history.push(`profile/form/${profile?.id}`)}
                            className="text-primary flex justify-center"
                            icon={IconPencilRevert}
                          />
                        </td>
                        <td>
                          <IconButton
                            onClick={() => setModalDelete({ id: profile?.id, name: profile?.name })}
                            className="text-secondary flex justify-center"
                            icon={IconTrash}
                          />
                        </td>
                      </tr>
                    )
                  );
                })
              ) : (
                <h1>Nenhum perfil cadastrado ou encontrado</h1>
              )}
            </tbody>
          </TableComponent>
          <ButtonNavigator list={profiles} page={page} setPage={setPage} selectSize={selectSize} setSelectSize={setSelectSize} />
        </div>
      </Spinner>
    </>
  );
}
